import companyType from '../type/company';

export default () => `
    orgs {
        ${companyType()}
    }
`;
